import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  commentVisibilityMock,
  courseRecommendMock,
  getCommentListMock,
  getCourseDetailMock,
  quizAnswersMock,
  successMock,
  surveyAnswersMock,
  surveyQuestionsMock,
} from './mock';
import {
  activityPath,
  activitySessionPath,
  certificatePath,
  coursePath,
  quizPath,
  surveyPath,
  trackingPath,
} from '../../utils/paths';

export default {
  getCourseDetails: ({ id }) => {
    if (shouldUseMock()) {
      return getCourseDetailMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/details`, 'GET');
  },
  getCourseDetailsUser: ({ id }) => {
    if (shouldUseMock()) {
      return getCourseDetailMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/user/details`, 'GET');
  },
  courseNotificationSet: ({ id, action }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}course/${id}/notifications`,
      'POST',
      { action }
    );
  },
  activitySetComment: ({ body, id }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/comment`, 'POST', body);
  },
  activitySetCommentReply: ({ body, id, cid }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}course/${id}/comment/${cid}/reply`,
      'POST',
      body
    );
  },
  activityGetCommentList: (id) => {
    if (shouldUseMock()) {
      return getCommentListMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/comment/list`, 'GET');
  },
  commentVisibility: ({ id, published }) => {
    if (shouldUseMock()) {
      return commentVisibilityMock();
    }
    return apiCall(`${baseUrl}${coursePath}comment/${id}/unpublish`, 'POST', {
      action: published,
    });
  },
  activitySetLikeDislike: ({ id, action_type }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    const disPrefix = action_type === 'like' ? '' : 'dis';
    return apiCall(
      `${baseUrl}${activityPath}activity/${id}/${disPrefix}like`,
      'POST',
      {}
    );
  },
  quizAnswers: (activity_id, body) => {
    if (shouldUseMock()) {
      return quizAnswersMock();
    }
    return apiCall(
      `${baseUrl}${quizPath}activity/${activity_id}/answers`,
      'POST',
      body
    );
  },
  eventQuizStart: (session_id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/quiz/start`,
      'POST',
      {}
    );
  },
  eventQuizAnswers: (session_id, body) => {
    if (shouldUseMock()) {
      return quizAnswersMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/quiz/answers`,
      'POST',
      body
    );
  },
  surveyQuestionsGet: () => {
    return surveyQuestionsMock();
  },
  surveyAnswers: (activity_id, body) => {
    if (shouldUseMock()) {
      return surveyAnswersMock();
    }
    return apiCall(
      `${baseUrl}${surveyPath}activity/${activity_id}/answers`,
      'POST',
      body
    );
  },
  getCertificate: (id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${certificatePath}course/${id}`, 'GET');
  },
  courseRecommend: (id, body) => {
    if (shouldUseMock()) {
      return courseRecommendMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}course/${id}/recommend`,
      'POST',
      body
    );
  },
  courseLeave: (id, body) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/leave`, 'POST', body);
  },
  quizStartTracking: (body) => {
    if (!shouldUseMock()) {
      return apiCall(
        `${baseUrl}${trackingPath}quiz_tracking/started/track`,
        'POST',
        body
      );
    }
  },
};
